import routesCreateComponent from './routes.create.component';

let routesCreateModule = angular.module('routescreate', [
  ])

  .component('routescreate', routesCreateComponent)

  .name;

export default routesCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/routes/create/index.js